export default function Configure($stateProvider) {
    $stateProvider.state('donnee-filtree-utilisateurs', {
        parent: 'common',
        url: '/donnee-filtree-utilisateurs',
        abstract: true,
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            // le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
            skip: true
        }
    });

    $stateProvider.state('donnee-filtree-utilisateurs.list', {
        url: '/list/{id}',
        template: '<donnee-filtree-utilisateurs></donnee-filtree-utilisateurs>',
        rights: { domain: 'utilisateurs', right: 'update' },
        ncyBreadcrumb: {
            label: '{{ "FILTRES.BREADCRUMBS.FILTRES_LIST" | translate}}'
        }
        //search: 'PERSONNES.BREADCRUMBS.FILTRES_LIST'
    });
}

Configure.$inject = ['$stateProvider'];
